<template>
  <div class="position-relative">
    <b-form-input
      v-model="selected_value"
      :disabled="enabled"
      @focus.native="is_close = false"
      @blur.native="handleBlur"
      autocomplete="off"
      maxlength="2"
      @keypress.native="handleKeypress"
      @input="error = null"
      :state="isInvalid(`${errorKey}`)"
      :class="['inputdropdown-text', { 'bg-disabled': enabled }]"
      placeholder="0">
    </b-form-input>
    <div
      id="options-container"
      class="bg-white position-absolute w-100" v-if="!is_close">
      <div v-for="(value, index) in computedItems" :key="`value_${index}`"
        class="px-3 py-2 cursor-pointer" @click.self="setSelectedValue(value)">
        {{ typeof value === 'object' ? value.text : value }}
      </div>
    </div>
    <b-form-invalid-feedback :force-show="isInvalid(`${errorKey}`)">{{ errorMessage(`${errorKey}`) }}</b-form-invalid-feedback>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "FulfillmentInputDropdown",
  props: ["enabled", "items", "origin", "selectedValue", "type", "errorKey", "parent"],
  data() {
    return {
      selected_value: null,
      is_close: true,
      error: null
    }
  },
  computed: {
    ...mapGetters({
      errors: 'orderFulfillment/errors',
      delivery_tab_settings: 'orderFulfillment/delivery_tab_settings',
      pickup_tab_settings: 'orderFulfillment/pickup_tab_settings'
    }),
    computedItems: {
      get() {
        return this.selected_value
          ? this.items.map(item => item.toString()).filter(item => item.includes(Number(this.selected_value)))
          : this.items;
      },
      set(items) {
        return items;
      }
    }
  },
  methods: {
    ...mapMutations({
      setErrors: 'orderFulfillment/set_errors'
    }),
    setSelectedValue(value) {
      this.selected_value = value && typeof value == 'string'
        ? Number(value)
        : value && typeof value == 'object'
          ? value.value
          : value;
      this.$emit("setValue", { type: this.origin, value: this.selected_value });
      this.$nextTick(() => {
        this.is_close = true;
        if (this.delivery_tab_settings && this.parent === 'scheduled_delivery') {
          const stored_lead_time = this.delivery_tab_settings.pre_order_schedule_settings.lead_time;
          if (this.selected_value !== stored_lead_time[this.origin]) this.$root.$emit("changesDetected");
        } else if (this.pickup_tab_settings && this.parent === 'scheduled_pickup') {
          const stored_lead_time = this.pickup_tab_settings.pre_order_schedule_settings.lead_time;
          if (this.selected_value !== stored_lead_time[this.origin]) this.$root.$emit("changesDetected");
        }
      });
    },
    handleBlur() {
      const error = {};
      setTimeout(() => {
        if (this.type !== 'minutes' && this.selected_value < this.items[this.items.length - 1] && this.selected_value < 1) {
          if ((this.pickup_tab_settings.pre_order_schedule_settings == 1  && this.parent === 'scheduled_delivery') || 
              (this.delivery_tab_settings.pre_order_schedule_settings == 1  && this.parent === 'scheduled_pickup')) {
            switch (this.type) {
              case 'hours':
                error[this.errorKey] = "Invalid Input for Hour. It only allows 1-24 only.";
                this.setErrors(error);
                break;
              case 'days':
                error[this.errorKey] = "Invalid Input for Day. It only allows 1-30 only.";
                this.setErrors(error);
                break;
              case 'weeks':
                error[this.errorKey] = "Invalid Input for Week. It only allows 1-32 only.";
                this.setErrors(error);
                break;
              case 'months':
                error[this.errorKey] = "Invalid Input for Month. It only allows 1-12 only.";
                this.setErrors(error);
                break;
              case 'years':
                error[this.errorKey] = "Invalid Input for Year. It only allows 1-5 only.";
                this.setErrors(error);
                break;
              default:
                break;
            }
          }
          this.selected_value = null;
          this.setSelectedValue(null);
        } else if (this.type === 'minutes' && this.selected_value !== null && (this.selected_value !== "30" && this.selected_value !== "60" && this.selected_value !== "90" && this.selected_value !== 30 && this.selected_value !== 60 && this.selected_value !== 90)) {
            error[this.errorKey] = "Invalid Input for Minutes. It only allows 30, 60, and 90 only.";
            this.setErrors(error);
            this.selected_value = null;
            this.setSelectedValue(null);
        } else {
          this.setErrors(null);
          const numValue = Number(this.selected_value);
          if (numValue !== 0) this.setSelectedValue(numValue);
        }

        this.$nextTick(() => {
          this.is_close = true;
        });
      }, 200);
    },
    handleKeypress(e) {
      if (this.isNotNumeric(String.fromCharCode(e.keyCode)))
        e.preventDefault();
    },
    isNotNumeric(input) {
      return /[^0-9\s]+/g.test(input);  
    },
    isInvalid(key) {
      return this.errors && this.errors[key]
        ? false
        : null;
    },
    errorMessage(key) {
      return this.errors && this.errors[key]
        ? this.errors[key]
        : null;
    }
  },
  watch: {
    selectedValue(value) {
      this.selected_value = value;
    },
    type() {
      this.handleBlur();
    }
  }
}
</script>

<style lang="scss" scoped>
.inputdropdown-text {
  background: url('../../assets/images/caret-down.svg') no-repeat center right 10px;
  &.bg-disabled {
    background-color: #E9EBED;
  }
}
#options-container {
  z-index: 1;
  max-height: 250px;
  overflow-y: auto;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
  border-radius: 5px;
}
</style>
